/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_CURRENCY_EXCHANGE_RATE = gql`
query GetCurrencyExchangeRate {
  getCurrencyExchangeRate {
    band
    conversion_rate
    currency
    payment_mode
    bandId
    eventTimeZone {
      tmz
      abbrevation
      offset
    }
  }
}
`;
